/* eslint-disable max-len */
import React, { useEffect } from 'react'
import LottieAnimation from '../Animation/LottieAnimation'
import emptysearch from '../../helpers/emptysearch.json'

export default function SearchEmptyScreen({text,setSkip,welnesscontact,vitalFilterHeight,resetPasswordHeight}) {
    useEffect(()=>{
        setSkip?setSkip(true):null
    },[])
    return (
        <div className={`flex flex-col 
        ${welnesscontact? 'h-fit' :
            vitalFilterHeight? 'h-[calc(100vh-376px)]' :
                resetPasswordHeight? 'h-screen' :
                    'h-customh5'} justify-center items-center  w-full`}>
            <div className='w-[320px]  h-[280px]'>
                <LottieAnimation loop={true} animateFile={emptysearch} height="250" width="250"/> 
            </div>
            <p className='text-xl font-normal text-[#000]'>{text}</p>
        </div>
    )
}
